import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fund-3a-bank-details',
  templateUrl: './fund-3a-bank-details.component.html',
  styleUrls: ['../../fund.component.scss'],
  standalone: false
})
export class Fund3aBankDetailsComponent {
  @Input() currentAccount;
}
